import $ from 'jquery';
import PropTypes from 'prop-types';
import React from 'react';

export default class FixedViewPortElement extends React.Component {
    constructor(props) {
        super(props);

        this.toggleFixedViewport = this.toggleFixedViewport.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isEnabled !== nextProps.isEnabled) {
            if (nextProps.isEnabled) {
                this.scrollPosition = $(document).scrollTop();
                this.toggleFixedViewport(true);
            } else {
                this.toggleFixedViewport(false);
                $(document).scrollTop(this.scrollPosition);
            }
        }
    }

    componentDidMount() {
        if (this.props.isEnabled) {
            this.scrollPosition = $(document).scrollTop();
            this.toggleFixedViewport(true);
        }
    }

    componentWillUnmount() {
        if (this.props.isEnabled) {
            this.toggleFixedViewport(false);

            if (this.scrollPosition) {
                $(document).scrollTop(this.scrollPosition);
            }
        }
    }

    toggleFixedViewport(isEnabled) {
        const body = document.querySelector('body');
        // body wont exist in shallow rendering
        if (body) {
            if (isEnabled) {
                body.setAttribute('data-fixed-viewport-active', true);
            } else {
                body.removeAttribute('data-fixed-viewport-active');
            }
        }
    }

    render() {
        return this.props.children;
    }
}

FixedViewPortElement.propTypes = {
    isEnabled: PropTypes.bool,
};

FixedViewPortElement.defaultProps = {
    isEnabled: true,
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/FixedViewportElement.jsx